module.exports = __webpack_public_path__ + "static/media/Icon 1.87605578.jpeg";